import { FracccionamientoIntegracionService } from './tabs/fraccionamiento-integracion/fraccionamiento-integracion.service ';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { DetalleBienCulturalService } from './detalle-bien-cultural.service';
import { environment as env } from 'environments/environments';
import { DocumentosEmitidosService } from './tabs/documentos-emitidos/documentos-emitidos.service';
import { GaleriaService } from './tabs/galeria/galeria.service';

@Injectable({ providedIn: 'root' })
export class DetalleBienCulturalResolver implements Resolve<any> {
    tipologiaServicios:number= env.TIPOLOGIA_ID_SERVICIO
    tipologiaValor:number = env.TIPOLOGIA_ID_VALOR

    constructor(
        private _detalleBienesService: DetalleBienCulturalService,
        private documetosEmitidosService:DocumentosEmitidosService,
        private fracccionamientoIntegracionService: FracccionamientoIntegracionService,
        private galeriaSevice: GaleriaService
    ){

    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const uu_id = route.paramMap.get('uu_id');

        return forkJoin([
            this._detalleBienesService.getTipologiasServicio(this.tipologiaServicios),
            this._detalleBienesService.getTipologiasValor(this.tipologiaValor),
            this._detalleBienesService.getFichaRegistro(uu_id),
            this.documetosEmitidosService.getDocumentosGenerados(uu_id),
            this.fracccionamientoIntegracionService.getFraccionamientoIntegraciones(uu_id),
        ]);

    }

}